// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2FuTP","filesListContainer":"PosDisputesFiles_filesListContainer__3Fz0e","filesButton":"PosDisputesFiles_filesButton__2cbgq"};